export const engagementCampaignDataCampaignId = "/engagement/campaign_data(/:campaign_id)";
